var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"links-wrapper"},[_c('ul',{staticClass:"links-list"},_vm._l((_vm.links),function(link,index){return _c('li',{key:index},[_c('router-link',{staticClass:"link-route",attrs:{"to":link.siteUrl},nativeOn:{"click":function($event){return _vm.handleLinkClick(link, $event)}}},[_vm._v(" "+_vm._s(link.name)+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }